/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ConversationModel {
  id: string;
  user_id: string;
  title: string | null;
  type: string | null;
  conversation_group_id?: string | null;
  initial_workflow_type?: string | null;
  curai_conversation_id: string | null;
  curai_room_id: string | null;
  curai_encounter_id: string | null;
  curai_clinician_full_name_with_title: string | null;
  closed: boolean | null;
  has_unread: boolean | null;
  attachment_count?: number | null;
  total_attachment_size?: number | null;
}
